export const isValidLatLng = (lat: number | undefined, lng: number | undefined): boolean =>
	lat && lng && lat > -90 && lat < 90 && lng > -180 && lng < 180;
